import { render, staticRenderFns } from "./Person26Text.vue?vue&type=template&id=f8fe5d80"
import script from "./Person26Text.vue?vue&type=script&lang=js"
export * from "./Person26Text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports